import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ClipLoader } from 'react-spinners'
import { replyToCurrentConversation } from '../../../actions/currentConversation/relpyToCurrentConversation'
import classNames from 'classnames'

export const MessageInput = ({}) => {
  const dispatch = useDispatch()
  const currentConversation= useSelector(state=>state.currentConversation)
  const [ body, setBody ] = React.useState("")
  const [ loading, setLoading ] = React.useState(false)
  const handleSend = () => {
    setLoading(true)
    dispatch(replyToCurrentConversation(currentConversation, body)).then(()=>{
      setLoading(false)
      setBody('')
    })
  }

  return(
    <div className={classNames("d-flex p-4", {"flex-column": window.innerWidth < 1450, "align-items-center": window.innerWidth > 1450})}>
      <input 
        value={body}
        className="w-100 form-control"
        onKeyUp={(e)=>{if (e.keyCode === 13) handleSend()}}
        onChange={(e)=>setBody(e.target.value)}/>
      <button onClick={handleSend} disabled={body.length == 0 || loading} className={classNames("btn btn-primary ml-3", { "mt-3": window.innerWidth < 1450})}>
        {
          loading ?
          <ClipLoader size={15} color="white"/> :
          'Send'
        }
      </button>
    </div>
  )
}
